import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class CheckPointAttribute extends AbstractBlock {
  constructor() {
    super('checkpoint', t.to('チェックポイント', 'check_point'));
    // this.setNameForCode("checkpoint");
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    ShapeSettings.setTitleField(block, this.title);

    const speed = new Blockly.FieldTextInput(1);
    block.appendDummyInput().appendField(t.to('スピード', 'speed')).appendField(speed, 'speed');

    const offset_y = new Blockly.FieldTextInput(1.7);
    block
      .appendDummyInput()
      .appendField(t.to(`頭の位置`, 'offset_y'))
      .appendField(offset_y, 'offset_y');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const speed = CodeSetting.getFieldValue(block, 'speed');
    const offset_y = CodeSetting.getFieldValue(block, 'offset_y');

    const str = CodeSetting.buildAttribute(
      [
        ['steppoint', `speed:${speed};offset_y:${offset_y}`],
        ['class', 'collidable'],
      ],
      attribute
    );
    return [str];
  }
}
